import type { Location } from 'history'
import qs from 'qs'

/**
 * When React hooks ship to production, we can replace this
 */
export function getUrlQuery<T>(_: { location: Location<any> }) {
  return qs.parse(decodeURI(location.search.substring(1, location.search.length)), {
    arrayLimit: 1000
  }) as unknown as T
}
